import { render } from "./tax-modal.vue?vue&type=template&id=d67ed40a"
import script from "./tax-modal.vue?vue&type=script&lang=js"
export * from "./tax-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__